export default class TableHeaders {


    public  get fields() {
        const component: any = this;
        return component[`${component.type}Fields`];
    }

    private type!: string;

    private districtFields: any = [
        {
           label: 'Name',
           key: 'name',
        },
        {
            label: 'Gooru ID',
            key: 'gooruId',
        },
        {
            label: 'Teacher Count',
            key: 'teacherCount',
        },
        {
            label: 'Student Count',
            key: 'studentCount',
        },
        {
            label: 'Status',
            key: 'status',
        },
    ];

    private schoolFields: any = [
        {
            label: 'Name',
            key: 'name',
         },
         {
             label: 'Gooru ID',
             key: 'id',
         },
         {
             label: 'Teacher Count',
             key: 'teacherCount',
         },
         {
             label: 'Student Count',
             key: 'studentCount',
         },
         {
            label: 'Class Count',
            key: 'classCount',
        },
         {
             label: 'Status',
             key: 'status',
         },
    ];

    private classesFields: any = [
        {
            label: 'Name',
            key: 'title',
         },
         {
             label: 'Class Type',
             key: 'classSharing',
         },
         {
             label: 'Subjects',
             key: 'preference.subject',
         },
         {
             label: 'Grade',
             key: 'gradeCurrent',
         },
         {
            label: 'Student Count',
            key: 'studentCount',
         },
         {
             label: 'Status',
             key: 'status',
         },

    ];


    private usersFields: any = [
         {
             label: 'Last Name',
             key: 'lastName',
             sortable: true,
         },
         {
            label: 'First Name',
            key: 'firstName',
        },
         {
             label: 'Email',
             key: 'email',
         },
         {
             label: 'Role',
             key: 'role',
         },
         {
             label: 'Status',
             key: 'status',
         },
         {
             label: 'Gooru ID',
             key: 'gooruId',
         },
    ];

    constructor(type: any) {
       this.type = type;
    }
}
